import type { TrainingType } from '@/entities/Training';

export const TRAINING_CONTROL_TYPES: readonly TrainingType[] = [
  'ONBOARDING',
  'ROLE_CHANGE',
  'SGQ_DOCUMENT_FOCAL',
  'SGQ_DOCUMENT_HOMOLOGATION',
  'OPEN_TRAINING',
];

export function isTrainingControlType(type: TrainingType): boolean {
  return TRAINING_CONTROL_TYPES.includes(type);
}
